import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="px-6 mt-27 py-12 max-w-5xl mx-auto text-black bg-white">
      <h1 className="text-3xl font-bold mb-6 text-center">Shipping Policy</h1>

      <p className="mb-4">
        At The Great Honey Co., we are committed to delivering our premium honey and honey-based products to you as quickly and efficiently as possible.
        Please review our shipping policy below for details on processing times, delivery estimates, and other important information.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">1) Do You Ship Across India?</h2>
      <p className="mb-4">
        Yes! We proudly ship to all locations across India.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">2) How Long Will It Take for My Order to Ship?</h2>
      <p className="mb-4">
        Orders are typically dispatched within 2–3 business days from our warehouse after confirmation.
        Delivery times depend on your location and chosen shipping option, generally ranging between 2–13 days.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">3) Delays & Public Holidays</h2>
      <ul className="list-disc ml-6 mb-4 space-y-2">
        <li>Shipping timelines may be affected during public holidays, festivals, and peak seasons.</li>
        <li>Additional delays may occur due to customs processing, postal congestion, or transportation strikes beyond our control.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">4) Responsibility After Dispatch</h2>
      <p className="mb-4">
        Once your order is shipped, any delays caused by natural occurrences, strikes, or transit issues are beyond our responsibility.
        We will, however, assist you in tracking and resolving any shipment issues to the best of our ability.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">5) Import Taxes & Duties (For International Orders)</h2>
      <p className="mb-4">
        Any import taxes, duties, or customs-related fees applicable in the destination country are not included.
      </p>
    </div>
  );
};

export default ShippingPolicy;
